import { APPLIED_IDENTITY_GLOBAL } from './identity-style'

import type { TenantIdentity } from './identity'

/**
 * A identidade que o bootstrap inline já pintou neste boot.
 *
 * Leitura síncrona e sem rede: é o que permite à topbar nascer com a
 * superfície do evento no primeiro frame do React, em vez de nascer branca e
 * escurecer quando o evento confirmado chega. `null` — primeiro boot, host sem
 * evento, armazenamento indisponível — mantém o chrome no comportamento neutro.
 */
export function readAppliedTenantIdentity(): TenantIdentity | null {
  if (typeof window === 'undefined') return null

  const applied = (window as unknown as Record<string, unknown>)[
    APPLIED_IDENTITY_GLOBAL
  ]

  return (applied as TenantIdentity | undefined) ?? null
}
